import { Box, makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { NumericFormat } from 'react-number-format';

import { Font } from '@/components/shared/components/Font';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface AviosTagProps {
  avios: number;
}

export const AviosTag = ({ avios }: AviosTagProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const isDarkTheme = palette.type === 'dark';

  const useStyles = makeStyles({
    text: {
      lineHeight: 1.3,
      fontWeight: 600,
      whiteSpace: 'nowrap',
      color: isDarkTheme ? palette.success.main : palette.success.dark,
    },
  });
  const classes = useStyles();

  const backgroundOpacity = isDarkTheme ? 0.3 : 0.2;

  return (
    <Box
      px={'8px'}
      py={'2px'}
      flexShrink={0}
      display={'inline-flex'}
      alignItems={'center'}
      borderRadius={customBorderRadius.chip}
      bgcolor={alpha(palette.success.main, backgroundOpacity)}
    >
      <Font variant={'caption'} className={`${classes.text} lining-typography`}>
        <NumericFormat
          value={avios}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          decimalScale={0}
          suffix={' Avios'}
        />
      </Font>
    </Box>
  );
};
